import { createFileRoute } from "@tanstack/react-router";
import { HomePage, homeHead } from "@/pages/HomePage";

export const Route = createFileRoute("/de/")({
  head: () => homeHead("de"),
  component: () => <HomePage locale="de" />,
});
